import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-divider",
  "use": "icon-divider-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-divider\"><defs><style type=\"text/css\"></style></defs><path d=\"M62.5 491.773h899v74.918h-899v-74.918z\" p-id=\"63667\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol